import { Component, Host, h, Element, Prop, State, Method, Listen } from '@stencil/core';
import Swiper, { Navigation } from 'swiper';
// import Flickity from 'flickity';
// import "flickity-hash";
import { jitsuClient } from '@jitsu/sdk-js'
// import posthog from 'posthog-js'
// if (!window.location.host.includes('127.0.0.1') && !window.location.host.includes('localhost')) {
//   posthog.init('phc_PFn3ipf7jR88MXFX73PMM6l7A0G5EeZf0llC0u5FVKv', { api_host: 'https://app.posthog.com', autocapture: false, capture_pageview: false})
// }
const jitsu = jitsuClient({
    key: "js.ku52f0vferwtf16hunn8p6.s4zhwpli8w7pwz9k0y1kc",
    tracking_host: "https://t.jitsu.com"
});

@Component({
  tag: 'as-carousel',
  styleUrl: 'as-carousel.css',
  shadow: true,
})
export class AsCarousel {

  @Element() el: HTMLElement;

  @Prop({ attribute: 'pid' }) playlistId: string;
  @Prop({ attribute: 'cid', mutable: true }) channelId?: string = null;
  @Prop() fsplaylist?: any;
  @Prop() env?: string = '';
  @Prop() mode?: string = 'default'; // default, autoplay
  @Prop() fullscreen?: boolean = false;
  @Prop() pt?: any = null; // parent carousel
  @Prop({ mutable: true }) platform?: any = 'web'; 
  @Prop() ep?: any = null;   //exclude product
  @Prop({ mutable: true }) mainElzIndex?: any = '';
  @Prop({ mutable: true }) selectedVid?: any = 0;
  @Prop({ mutable: true }) tk: boolean = true;
  @Prop({ mutable: true }) variant?: string = "title";
  @Prop() ch?: number = 400;
  @Prop() size?: string = 'default';

  @State() carouselReady: boolean = false;
  @State() carouselPlayerReady: boolean = false;
  @State() activeVideoId: string = null;
  @State() flkCsl: any = [];
  @State() fullscreenOpen: boolean = false;
  @State() playlist: any = null;
  @State() loading: boolean = true;
  @State() forcemute: boolean = false;
  @State() cslready: boolean = false;
  @State() swiperloaded: boolean = false;
  
  private autofullscreen: boolean = false;
  private hoverPlayer: any = null;
  private fullscreenPlayer: any = null;
  private viewport: boolean = false;
  private viewportcount: number = 0;
  private showfootertitle: boolean = true;
  private showProductChip: boolean = false;
  private showProductCard: boolean = false;
  private items: any = [];
  private observer: IntersectionObserver;
  // private remaining: number = 0;


  @Listen('scroll', { target: 'window' })
  async scrollPage() {
    // await this.checkVisibleItems(this);
    return Promise.resolve();
  }

  @Listen('load', { target: 'window' })
  async onPageLoaded() {
    // const els = this.el.shadowRoot.querySelectorAll('.carousel-cell');
    // els.forEach((el, index) => {
    //   if(index < 12) {
    //     this.loadEle(el, null);
    //   }
    // });
  }


  @Method()
  async selectIndex(index) {
    // show a prompt
    // console.log('selecting index', this.flkCsl, index);
    this.selectedVid = index;
    const asreels: any = this.el.shadowRoot.querySelector('as-reels');
    asreels?.enter(this.selectedVid);
    // if(force) {
    //   this.flkCsl[0].select(this.selectedVid);
    // }
    this.trackEvent('full_screen', {
      category: 'carousel',
      index,
      type: this.items[index].type,
      typeid: this.items[index].typeId,
      videoid: (this.items[index].type === 'video') ? this.items[index].typeId : null,
      photoid: (this.items[index].type === 'photo') ? this.items[index].typeId : null,
    });
    // this.flkCsl[0].select(index);
    return Promise.resolve();
  }

  @Method()
  async exitFullScreen() {
    // show a prompt
    // console.log('exiting full screen', this.flkCsl);

    // const aplayers: any = this.el?.shadowRoot.querySelectorAll(".carousel-cell as-player");
    // console.log('pause a players', aplayers, this.selectedVid);
    // if(aplayers) {
    //   await aplayers?.forEach(async (p) =>await p.pause());
    // }

    // this.flkCsl[0].exitFullscreen();
    const asreels: any = this.el.shadowRoot.querySelector('as-reels');
    asreels?.exit();

    this.trackEvent('close_full_screen', {
      category: 'carousel',
    });

    return Promise.resolve();
  }

 componentWillLoad() {
    if(this.size === 'mini') {
      this.ch = 240;
    }
    var style = document.createElement( 'style' )
    style.innerHTML = `:root { --ascarousel-ch: ${this.ch}px; }`;
    if(this.ch <= 360) {
      style.innerHTML = `${style.innerHTML}  @media (min-width: 768px) { :root { --ascarousel-ch: ${this.ch*1.5}px; } }`;
    }
    document.body.appendChild( style );
  
    if(this.tk === undefined) {
      this.tk = true;
    }
    if(!this.fullscreen) {
      const mainEl: any = this.getHighestParent(this.el);
      this.mainElzIndex = mainEl.style.zIndex;
      // console.log(mainEl, this.mainElzIndex);
    }
    if(this.variant != 'title') {
      this.showfootertitle = false;
    }
    if(this.variant === 'chip') {
      this.showProductChip = true;
    }
    if(this.fullscreen) {
      this.showfootertitle = false;
      this.showProductCard = true;
      this.showProductChip = false;
    }

    this.playlist = this.fsplaylist || null;
    this.items = this.playlist?.itemsdata || [];
    if(!this.fsplaylist) {
      for(var i=0; i<10; i++) {
        this.items.push({
          title: '',
          url: null,
          loading: true,
        });
      }
    } else {
      this.loading = false;
    }
  }

  async componentDidLoad() {
    // this.setupLoadingFlkty();
    var style = document.createElement( 'style' )
    style.innerHTML = `.carouselWrapper { --ascarousel-ch: ${this.ch}px; }`;
    if(this.ch <= 360) {
      style.innerHTML = `${style.innerHTML}  @media (min-width: 768px) { .carouselWrapper { --ascarousel-ch: ${this.ch*1.5}px; } }`;
    }
    this.el.shadowRoot.appendChild( style );

    if(!this.fsplaylist) {
      let cheader = {
        "Content-type": "application/json;charset=UTF-8",
      };

      if(this.channelId) {
        cheader["channel_id"] = this.channelId;
      }
      const playlistResponse = await fetch(`${this.getApiUrl(this.env)}/web/playlists/${this.playlistId}`, {
        method: "GET",
        headers: cheader,
      });
      if(playlistResponse.status === 200) {
        this.playlist = await playlistResponse.json();
        this.items = this.playlist.itemsdata;
        this.loading = false;
      } else {
        return false;
      }
    }
    if(this.items.length >0) {
      this.channelId = this.playlist.channelId;
      if(this.tk) {
        jitsu.set({
          channelid : this.channelId,
          playlistid: this.playlistId,
          env: this.env === '' ? 'live' : this.env,
          appid: 'allstudio',
          accountid: this.playlist.channel?.accountId,
          mode: this.mode,
          category: 'carousel'
        });

        //group posthog
        // posthog.group('accountid', `${this.env === 'live' || this.env === '' ? '': `${this.env}_`}${this.playlist.channel?.accountId}`, {
        //   env: this.env,
        //   channelid: this.channelId,
        //   channel: this.playlist.channel?.title,
        // });
      }
    } else {
      return false;
    }


    if(this.items) {
      if(window.location.hash.includes("#as-playlist-item-true")) {
        this.autofullscreen = true;
        this.forcemute = true;
      }

      if(this.ep) {
        // console.log('excluding current product', this.ep);
        this.items = this.items?.filter((v: any) => (v.data?.shoppableData?.productId !== this.ep));
      }


      window.history.pushState({
        fullscreen: false,
        firststate: true,
      }, null, "");
      
      const s = this;

      setTimeout(() => s.setupObserver(),0);
          
      if(this.autofullscreen && !this.fullscreen) {
        const mainEl: any = this.getHighestParent(this.el);
        mainEl.style.zIndex = 2147483647;
        this.fullscreenOpen = true;
      }
      this.backCheck();
     
    }
    // final
  }

  render() {
      return (
        <Host>
          <div class={{ carouselWrapper: true, fullScreen: this.fullscreen, sizemini: (this.size === 'mini') }} >
            {this.loading && (<div id={`as-carousel-${this.playlistId}-${this.fullscreen}-loading`} 
            class={this.fullscreen ? 'fs-as-carousel-loading swiper': 'as-carousel-loading swiper'}>
              <div class="swiper-wrapper">
              { 
                this.items?.map(() => (
                <div class="carousel-cell swiper-slide"  key={`as-playlist-video-${this.fullscreen}-${this.playlistId}-${Date.now()*Math.random()}-loading`}>
                 <div class="cards">
          <div class="card_image loading"></div>
          {/* <div class="card_description loading"></div> */}
        </div> 
                </div>
                ))
              }
              </div>
            </div>)}

{!this.loading && <div id={`as-carousel-${this.playlistId}-${this.fullscreen}-loaded`} class='as-carousel swiper'>
  <div class="swiper-wrapper">
  { 
    this.items?.map((item, index) => (
    <div class="carousel-cell swiper-slide" id={`as-playlist-item-${this.fullscreen}-${this.playlistId}-${item.type}-${item.typeId}`} 
    key={`as-playlist-item-${this.fullscreen}-${this.playlistId}-${item.type}-${item.typeId}`}>
      {this.carouselReady && item.type === 'video' ? (
      <as-player
      size={this.size}
      index={index}
      // productoverlay={this.el.shadowRoot.querySelector('as-product-overlay')}
      tk={this.tk}
      playlistId={this.playlistId}
      videoId={item.typeId}
      env={this.env}
      autoplay={this.mode === 'autoplay' ? true : false}
      fullscreen={this.fullscreen}
      fvideo={item.data}
      platform={this.platform}
      showheader={this.fullscreen}
      showfootertitle={this.showfootertitle}
      showproductchip={this.showProductChip}
      showproductcard={this.showProductCard}
      forcemute={this.fullscreen ? this.forcemute : null}
      widget={`carousel_player${this.fullscreen ? '_fullscreen' : ''}`}
      playclick={this.fullscreen ? false : (() => {
        // const fel: any = this.el.shadowRoot.querySelector('.fullScreenCarousel as-carousel');
        // fel?.selectIndex(index);

        const asreels: any = this.el.shadowRoot.querySelector('as-reels');
        asreels?.enter(index);

        // const aplayers: any = this.el?.shadowRoot.querySelectorAll(".as-carousel as-player");
        // aplayers?.forEach((item) => {
        //   item?.pause();
        //     });
        if(this.fullscreenOpen) {
          const mainEl: any = this.getHighestParent(this.el);
          mainEl.style.zIndex = 2147483647;
          this.el.shadowRoot.querySelector('.fullScreenCarousel').classList.add('isOpen');
        } else {
          const mainEl: any = this.getHighestParent(this.el);
          mainEl.style.zIndex = 2147483647;
          this.fullscreenOpen = true;
        }
        //fel?.selectIndex(index);
        this.selectedVid = index;
      })}
      piphandler={!this.fullscreen ? false : (() => {
        // const fel: any = this.el.shadowRoot.querySelector('.fullScreenCarousel as-carousel');
        // console.log('handling pip', fel);
        this.fullscreenPlayer?.pause();
        this.exitFullScreen();
        // this.fullscreenOpen = false;
        // this.el.shadowRoot.querySelector('.fullScreenCarousel').classList.remove('isOpen');
      })}
      mutehandler={!this.fullscreen ? false : ((val) => {
        this.forcemute = val;
        // console.log('mute handler', this.forcemute);
        const aplayers: any = this.el?.shadowRoot.querySelectorAll(".fs-as-carousel as-player");
        aplayers?.forEach((item) => {
          item?.muted(this.forcemute);
            });
      })}

      ></as-player>
      ) : <div></div>}

{this.carouselReady && item.type === 'photo' ? (
      <as-photo-viewer
      size={this.size}
      index={index}
      // productoverlay={this.el.shadowRoot.querySelector('as-product-overlay')}
      tk={this.tk}
      playlistId={this.playlistId}
      photoId={item.typeId}
      env={this.env}
      fullscreen={this.fullscreen}
      fphoto={item.data}
      platform={this.platform}
      showheader={this.fullscreen}
      showfootertitle={this.showfootertitle}
      showproductchip={this.showProductChip}
      showproductcard={this.showProductCard}
      widget={`carousel_photo_viewer${this.fullscreen ? '_fullscreen' : ''}`}
      playclick={this.fullscreen ? false : (() => {
        // const fel: any = this.el.shadowRoot.querySelector('.fullScreenCarousel as-carousel');
        // fel?.selectIndex(index);

        const asreels: any = this.el.shadowRoot.querySelector('as-reels');
        asreels?.enter(index);

        if(this.fullscreenOpen) {
          const mainEl: any = this.getHighestParent(this.el);
          mainEl.style.zIndex = 2147483647;
          this.el.shadowRoot.querySelector('.fullScreenCarousel').classList.add('isOpen');
        } else {
          const mainEl: any = this.getHighestParent(this.el);
          mainEl.style.zIndex = 2147483647;
          this.fullscreenOpen = true;
        }
        this.selectedVid = index;
      })}
      piphandler={!this.fullscreen ? false : (() => {
        // const fel: any = this.el.shadowRoot.querySelector('.fullScreenCarousel as-carousel');
        // console.log('handling pip', fel);
        this.exitFullScreen();
        // this.fullscreenOpen = false;
        // this.el.shadowRoot.querySelector('.fullScreenCarousel').classList.remove('isOpen');
      })}
      ></as-photo-viewer>
      ) : <div></div>}
      </div>))
  }
  </div>
  <div class="swiper-button-prev"></div>
  <div class="swiper-button-next"></div>
  </div>}

  {(!this.fullscreen && !this.loading && this.swiperloaded) ? (<as-reels playlistId={this.playlistId} fullscreen={true} 
              fsplaylist={this.playlist} open={false} env={this.env} platform={this.platform} ></as-reels>) : <div></div>}


            {/* <as-product-overlay trackevent={this.trackEvent} env={this.env}></as-product-overlay> */}

          </div> 
   
        </Host>
      );
  }


  getApiUrl (env?: string): string {
    let apiUrl = `https://apiv2.allstudio.live`;
    if(env === 'dev') {
      apiUrl = `${apiUrl}/dev`
    } else if(env === 'qa') {
      apiUrl = `${apiUrl}/qa`
    } else if(env === 'local') {
      apiUrl = 'http://localhost:4011';
    }
    return apiUrl;
  }
  
  getVideoUrl (vid: any): string {
    let finalUrl: string = vid.url;
    try {
      if (vid.isProcessed && vid.processedUrls['576p']) {
        finalUrl = vid.processedUrls['576p'];
      } 
    } catch(e) {
      finalUrl = vid.url;
    }
    // console.log('finalUrl', finalUrl);
    return finalUrl;
  }

  getHighestParent(el) {
    let parent = el;
    while (parent) {
      if (parent.parentNode?.tagName === 'BODY') {
        break;
      }
      parent = parent.parentNode;
    }
    // console.log('parent', parent);
    return parent;
  }

  isInViewport(el) {
    const rect = el?.getBoundingClientRect() || {
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
    };
    // console.log(rect);
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }



  async checkVisibleItems(s = this, hoverIndex = null) {

      if(!s.fullscreen) {
        const acarousel: any = s.el?.shadowRoot.querySelector(".as-carousel");
        if(s.isInViewport(acarousel)) {
          if(!s.viewport) {
            s.viewport = true;
            s.viewportcount++;
            s.trackEvent('impression', {
                category: 'carousel',
                view_count: s.viewportcount,
              });
          }
        }
        else {
          s.viewport = false;
        }
        const aplayers: any = s.el?.shadowRoot.querySelectorAll(".as-carousel .carousel-cell");
        if(aplayers.length === s.items.length) {
            if(s.mode === 'default') {
              s.hoverPlayer = null;
            }
            aplayers?.forEach((item, index) => {
              const p = item.querySelector('as-player');
              if(p && s.items[index].type === 'video') {
                // console.log('visible player', p, index, p ? s.isInViewport(p) : false);
                if(s.mode === 'autoplay') {
                  // console.log('visible trying to play');
                  p?.play();
                  s.hoverPlayer = p;
                  // s.trackEvent("viewport_play_video", {
                  //     index,
                  //     type: 'video',
                  //     typeid: p?.videoId,
                  //     videoid: p?.videoId,
                  //     category: "carousel",
                  //   });
                } else {
                  if(!s.hoverPlayer && hoverIndex === null) {
                    s.hoverPlayer = p;
                    p?.play();
                    // s.trackEvent("viewport_play_hover_video", {
                    //     index,
                    //     type: 'video',
                    //     typeid: s.hoverPlayer?.videoId,
                    //     videoid: s.hoverPlayer?.videoId,
                    //     category: "carousel",
                    //   });
                  } else if (hoverIndex === index) {
                    // console.log('pause hover player');
                    // s.hoverPlayer?.pause();
                    s.hoverPlayer = p;
                    p?.play();
                    s.hoverPlayer = p;
                    // s.trackEvent("viewport_play_video", {
                    //     index,
                    //     type: 'video',
                    //     typeid: p?.videoId,
                    //     videoid: p?.videoId,
                    //     category: "carousel",
                    //   });
                  } else if(s.hoverPlayer && s.hoverPlayer?.videoId !== p?.videoId) {
                    // console.log('not hover player so pause from visible', p.videoId, s.hoverPlayer.videoId);
                    // p.pause();
                    // s.trackEvent("viewport_pause_video", {
                    //     videoid: p?.videoId,
                    //     category: "carousel",
                    //   });
                  } else if(s.mode === 'default' && s.hoverPlayer){
                    if(s.hoverPlayer.videoId === p.videoId) {
                      s.hoverPlayer.play();
                      // s.trackEvent("viewport_play_hover_video", {
                      //     index,
                      //     type: 'video',
                      //     typeid: s.hoverPlayer?.videoId,
                      //     videoid: s.hoverPlayer?.videoId,
                      //     category: "carousel",
                      //   });
                    } else {
                      // s.hoverPlayer.pause();
                      // s.trackEvent("viewport_pause_hover_video", {
                      //     videoid: s.hoverPlayer?.videoId,
                      //     category: "carousel",
                      //   });
                    }
                  }
                }
              } else if (s.items[index].type === 'video' && !p) {
                setTimeout(async ()=> await s.checkVisibleItems(s), 100);
              }
            });
        } else {
          setTimeout(async ()=> await s.checkVisibleItems(s), 100);
        }
      }
    
  }

  async addHoverListener(s = this) {

      if(!s.fullscreen && !s.fullscreenOpen && s.mode === 'default') {
        const aplayers: any = s.el?.shadowRoot.querySelectorAll(".as-carousel .carousel-cell");
        if(aplayers.length === s.items.length) {
            aplayers.forEach((item, index) => {
              const p = item.querySelector('as-player');
              if(p && s.items[index].type === 'video') { 
                p.addEventListener("mouseover", function () {
                  // console.log('mouse over player', p, index);
                  if(s.hoverPlayer?.videoId !== p?.videoId && !s.hoverPlayer?.isPlaying) {
                    // console.log('mouse over player change', p, index);
                    // s.hoverPlayer?.pause();
                    // s.trackEvent("pause_hover_video", {
                    //   videoid: s.hoverPlayer?.videoId,
                    //   category: "carousel",
                    // });
                    s.hoverPlayer = p;
                    s.hoverPlayer?.play();
                    // s.trackEvent("play_hover_video", {
                    //   index,
                    //   type: 'video',
                    //   typeid: s.hoverPlayer?.videoId,
                    //   videoid: s.hoverPlayer?.videoId,
                    //   category: "carousel",
                    // });
                  }
                }, {
                  passive: true,
                });
              } else if(!p && s.items[index].type === 'video') {
                setTimeout(()=> s.addHoverListener(s), 100);
              }
            });
          } else {
            setTimeout(()=> s.addHoverListener(s), 100);
          }
      }
  }




  checkSetupFlkty(s) {
      const videonodes = s.el?.shadowRoot.querySelectorAll(`${this.fullscreen ? '.fs-as-carousel .carousel-cell': '.as-carousel .carousel-cell'}`);
      if(videonodes?.length === s.items.length){
        s.setupFlkty();
      } else {
        setTimeout(() => s.checkSetupFlkty(s), 100);
      }
  }
 
  setupFlkty() {
    // console.log('setting up flkty', this.items, this.fullscreen);
    const els = this.el.shadowRoot.querySelectorAll('.carousel-cell');
    els.forEach((el) => {
        this.loadEle(el, null);
    });

    this.swiperloaded = true;

    var selector = '.as-carousel';
    var elem: any = this.el?.shadowRoot.querySelector(selector);
       // console.log('element', elem, selector);
          const s = this;
          const nextEl: any = this.el?.shadowRoot.querySelector(`.swiper-button-next`);
          const prevEl: any = this.el?.shadowRoot.querySelector(`.swiper-button-prev`);

          try {
          var flk = new Swiper(elem, {
            modules: [Navigation],
            direction: 'horizontal',
            grabCursor: true,
            slidesPerView: 'auto',
            navigation: {
              nextEl,
              prevEl,
            },
            // initialIndex: (s.fullscreen) ? s.pt.selectedVid : 0,
            
            on: {
              afterInit: function(){
                // console.log('flk ready', elem, s.autofullscreen, s.fullscreen, s.loading);
                  s.carouselReady = true;
                  // s.addHoverListener(s);
              },
              slideChange: async function() {
                // console.log('change', swiper.activeIndex, s.loading);
                // const oel: any = s.el.shadowRoot.querySelector('as-product-overlay');
                // oel?.close();
                if(!s.loading) {
                  // await s.checkVisibleItems(s, swiper.activeIndex);
                }
              },
            },
          });
        s.flkCsl.push(flk);
       // console.log('flkcsl', s.flkCsl);
        if(s.fullscreen) {
          // s.flkCsl[0].viewFullscreen();
          const asreels: any = this.el.shadowRoot.querySelector('as-reels');
          asreels?.enter(0);

          window.history.pushState({
            fullscreen: true,
          }, null, "");
        }
      } catch(e) {
        setTimeout(() => s.setupFlkty(), 100);
      }
  }

  backCheck() {
    var s = this;
    window.addEventListener('popstate', function (e) {
      // console.log(e.state);
      if(!e.state?.fullscreen || e.state?.firststate) {
        e.preventDefault();
        // s.fullscreenPlayer?.pause();
        // s.flkCsl[0].exitFullscreen();
        const asreels: any = s.el.shadowRoot.querySelector('as-reels');
        asreels?.exit();
        // window.location.hash='';
      } else if(!e.state?.firststate && e.state.fullscreen && s.el.shadowRoot.querySelector('as-product-overlay')?.isVisible()) {
        e.preventDefault();
        s.el.shadowRoot.querySelector('as-product-overlay')?.handleOverlay(e);
      } else {
        e.preventDefault();
        // window.location.hash='';

        // s.fullscreenPlayer?.pause();
        // s.flkCsl[0].exitFullscreen();
        const asreels: any = s.el.shadowRoot.querySelector('as-reels');
        asreels?.exit();
        window.history.replaceState({
          fullscreen: false,
        }, null, "");
      }
    }, {
      passive: true,
    });
  }

  loadEle(ele, observerRef) {
    const nel = this.el.shadowRoot.querySelector(`#${ele.getAttribute('id')}`);
    const cel: any = nel?.querySelector('as-player') || nel?.querySelector('as-photo-viewer');
    if(cel) {
      if(nel.querySelector('as-player')) {
        if(!observerRef) {
          cel?.load();
        } else {
          cel?.play();
        }
      } else {
        cel?.load();
        if(observerRef) {
          observerRef.unobserve(ele);
        }
      }
    } else {
      setTimeout(() => this.loadEle(ele, observerRef),100);
    }
  }

  pauseEle(ele) {
    const nel = this.el.shadowRoot.querySelector(`#${ele.getAttribute('id')}`);
    const cel: any = nel?.querySelector('as-player') || nel?.querySelector('as-photo-viewer');
    if(cel) {
      if(nel.querySelector('as-player')) {
        cel?.pause();
      }
    } else {
      setTimeout(() => this.pauseEle(ele),100);
    }
  }

  setupObserver() {
    // console.log('observer setup');

    const obs = new IntersectionObserver((entries, observerRef) => {
      // The callback is run when the visibility of one or more of the elements
      // being observed has changed. It's also called on page load.
      entries.forEach(async (entry) => {
        //`isIntersecting` will be `true` if any part of the element is currently visible
        if (entry.isIntersecting) {
          // We are assuming here that your Web Component is located in a file
          // named after it's tag name
          this.checkSetupFlkty(this);
          // Once we've observed this element come into view, we can safely remove
          // the observer since we won't need to import the WC code again
          observerRef.unobserve(entry.target);

          this.observer = new IntersectionObserver((entries, observerRef) => {
            // The callback is run when the visibility of one or more of the elements
            // being observed has changed. It's also called on page load.
            entries.forEach(async (entry) => {
              //`isIntersecting` will be `true` if any part of the element is currently visible
              if (entry.isIntersecting) {
                // We are assuming here that your Web Component is located in a file
                // named after it's tag name
      
                this.loadEle(entry.target, observerRef);
                // Once we've observed this element come into view, we can safely remove
                // the observer since we won't need to import the WC code again
                // observerRef.unobserve(entry.target);
          
              } else {
                this.pauseEle(entry.target);
              }
            });
          }, {
            rootMargin: '80px 0px 40px'
          });
          const els = this.el.shadowRoot.querySelectorAll('.carousel-cell');
          els.forEach((el) => {
            this.observer.observe(el);
          });

        }
      });
    }, {
      rootMargin: '120px 0px 50px'
    });
    setTimeout(() => {
    const els1 = this.el.shadowRoot.querySelectorAll('.as-carousel');
    els1.forEach((el) => {
      obs.observe(el);
    });
    }, 100);
    
  }

  trackEvent(name, data) {
    try {
    if(this.tk || this.tk === undefined) {
      // console.log('tracking event', name, data);
      jitsu.set({
        channelid : this.channelId,
        playlistid: this.playlistId,
        env: this.env === '' ? 'live' : this.env,
        appid: 'allstudio',
        accountid: this.playlist.channel?.accountId,
        mode: this.mode,
      });

      // posthog.register_once({
      //   channelid : this.channelId,
      //   playlistid: this.playlistId,
      //   env: this.env === '' ? 'live' : this.env,
      //   appid: 'allstudio',
      //   accountid: this.playlist.channel?.accountId,
      //   mode: this.mode,
      // });

      try {
        jitsu.track(name, data);
        // posthog.capture(name,data);
      } catch(e) {
        console.log('jitsu tracking error', e);
      }
    }
  } catch(e) {
    console.log('track event', e.message);
  }
  }

}

